import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../selectors';
import * as appActions from '../actions';
import App from './App.component';

const AppContainer = props => <App {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	config: apiSelectors.config.configSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
	targetAlias: apiSelectors.target.aliasSelector(state),
});

const mapDispatchToProps = dispatch => ({
	createNotification: bindActionCreators(appActions.ui.uiActions.notification, dispatch),
});

AppContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(AppContainer)
);



// WEBPACK FOOTER //
// ./src/ui/App.container.js